<template lang="pug">
  b-modal(ref="modal" hide-footer title="Sincronizar Estado con Partner" size="lg" @hidden="clear")
    b-alert.mb-2(v-if="results" :show="true" variant="info")
      .d-flex(style="gap: 16px; flex-wrap: wrap")
        span Total: {{ results.total }}
        span.text-success Sincronizados: {{ results.synced.length }}
        span.text-danger Fallidos: {{ results.failed.length }}
        span.text-warning No encontrados: {{ results.notFound.length }}
      div(v-if="results.failed.length" style="max-height: 120px; overflow-y: auto").mt-2
        div(v-for="f in results.failed" :key="f.id")
          strong Id {{ f.id }}:
          |  {{ f.error }}
    b-form(@submit.stop.prevent="onSubmit")
      b-form-group
        .input-title Ids de Envíos
        v-select(multiple v-model="form.ids" taggable placeholder="Selecciona o escribe los ids de envíos" @input="onIdsChange")
      div(v-if="notFoundIds.length && !loadingDeliveries")
        .text-warning.mb-2 {{ notFoundIds.length }} envíos no encontrados: {{ notFoundIds.join(', ') }}
      h5(v-if="deliveries.length") {{ deliveries.length }} Envíos Seleccionados
      b-table(:items="deliveries" :fields="tableFields" responsive :busy="loadingDeliveries")
        template(#cell(state)="{value}")
          b-badge(v-if="value === 'Entregado'" variant="success") {{ value }}
          b-badge(v-else-if="value === 'Rechazado'" variant="danger") {{ value }}
          b-badge(v-else-if="value === 'Cancelado'" variant="cancelado") {{ value }}
          b-badge(v-else-if="value === 'Pendiente'" variant="warning").text-white {{ value }}
          b-badge(v-else variant="light") {{ value }}
        template(#cell(partnerDeliveryStatus)="{value, item}")
          span(v-if="!results") {{ value || 'Sin estado' }}
          b-badge(v-else-if="item.syncStatus === 'synced'" variant="success") {{ value || 'Sincronizado' }}
          b-badge(v-else-if="item.syncStatus === 'failed'" variant="danger") Error
          b-badge(v-else variant="light") {{ value || 'Sin estado' }}
      .text-right.mt-3
        b-button(variant="outline-primary" @click="close" :disabled="loading") Cerrar
        b-button.ml-2(type="submit" variant="primary" :disabled="loading || !form.ids.length")
          span(v-if="loading")
            b-spinner.mr-2(small)
          | Sincronizar
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    ids: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      loadingDeliveries: false,
      results: null,
      deliveries: [],
      form: {
        ids: []
      },
      tableFields: [
        { key: 'id', label: 'Id' },
        { key: 'customerName', label: 'Cliente' },
        { key: 'storeName', label: 'Tienda' },
        { key: 'state', label: 'Estado' },
        { key: 'partnerCode', label: 'Partner' },
        { key: 'partnerDeliveryStatus', label: 'Estado Partner' }
      ]
    }
  },
  methods: {
    ...mapActions(['bulkSyncPartnerStatus', 'getDeliveriesByIds']),
    clear () {
      this.results = null
      this.deliveries = []
      this.form.ids = []
      this.loading = false
    },
    close () {
      this.$refs.modal.hide()
    },
    show (ids = []) {
      this.results = null
      this.deliveries = []
      this.form.ids = [...ids]
      this.$refs.modal.show()
      if (ids.length) {
        this.fetchDeliveries()
      }
    },
    onIdsChange () {
      this.results = null
      this.fetchDeliveries()
    },
    async fetchDeliveries () {
      if (!this.form.ids.length) {
        this.deliveries = []
        return
      }
      this.loadingDeliveries = true
      try {
        const params = { ids: this.form.ids.toString() }
        const response = await this.getDeliveriesByIds(params)
        this.deliveries = response.data
      } catch (error) {
        this.deliveries = []
      } finally {
        this.loadingDeliveries = false
      }
    },
    async onSubmit () {
      if (!this.form.ids.length) return
      this.loading = true
      this.results = null
      try {
        const ids = this.form.ids.map(id => {
          return typeof id === 'string' ? parseInt(id.trim()) : id
        }).filter(id => Number.isInteger(id))

        const response = await this.bulkSyncPartnerStatus({ data: { ids } })
        this.results = response.data

        this.deliveries = this.deliveries.map(d => {
          if (this.results.synced.includes(d.id)) {
            return { ...d, syncStatus: 'synced' }
          }
          if (this.results.failed.some(f => f.id === d.id)) {
            return { ...d, syncStatus: 'failed' }
          }
          return d
        })

        const { synced, failed, notFound, total } = this.results
        const hasErrors = failed.length || notFound.length
        this.$root.$bvToast.toast(
          `${synced.length} sincronizados, ${failed.length} fallidos, ${notFound.length} no encontrados de ${total}`,
          {
            title: hasErrors ? 'Sincronización parcial' : 'Sincronización completada',
            variant: hasErrors ? 'warning' : 'success'
          }
        )
        this.$emit('done')
      } catch (error) {
        this.$root.$bvToast.toast(error?.response?.data?.message || 'Error al sincronizar', {
          title: 'Error',
          variant: 'danger'
        })
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    foundedIds () {
      return this.deliveries.map(d => d.id)
    },
    notFoundIds () {
      return this.form.ids.filter(id => {
        const parsedId = typeof id === 'string' ? parseInt(id.trim()) : id
        return Number.isInteger(parsedId) && !this.foundedIds.includes(parsedId)
      })
    }
  }
}
</script>
